module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-shipping-5cdadd3b09e5e611911f99f130a32eac.svg";